import axios from 'axios'

import { BRUTUS_URL } from '@src/Core/Constants/RouteConstants'
import { ConnectorResult } from '@src/Infrastructure/Types/ConnectorResult'
import { GetRoutesError, GetRoutesParams, GetRoutesResponse } from '@src/Infrastructure/Types/GetRoutes'
import { Route } from '@src/Infrastructure/Types/Routes'

export const GET_ROUTES_ENDPOINT = '/api/v1/quotes/get-routes/FCL/P2P'

export const getRoutesEndpoint = (params: GetRoutesParams): string => {
    const urlSearchParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            urlSearchParams.append(key, `${value}`)
        }
    })

    return `${GET_ROUTES_ENDPOINT}?${urlSearchParams.toString()}`
}

export const getRoutes = async (params: GetRoutesParams): Promise<ConnectorResult<Route[], GetRoutesError>> => {
    try {
        const { data, status } = await axios.get<GetRoutesResponse>(getRoutesEndpoint(params), {
            baseURL: BRUTUS_URL,
        })

        if (status !== 200) {
            return { errors: [{ code: 'INTERNAL_ERROR' }] }
        }

        return {
            data: data.data,
        }
    } catch (e) {
        return { errors: [{ code: 'UNKNOWN_ERROR' }] }
    }
}
